"use client"

import { Moon, Sun } from "lucide-react"

import { useTheme } from "@/lib/theme"
import { Button } from "@/components/ui/button"

/**
 * Light/dark toggle.
 *
 * Renders an inert placeholder until `mounted` — the server cannot know the
 * stored theme, so drawing an icon before the client reads it guarantees a
 * hydration mismatch (server draws Sun, client draws Moon).
 */
export function ThemeToggle({
  size = "sm",
  variant = "ghost",
}: {
  size?: "sm" | "default" | "lg" | "icon"
  variant?: "ghost" | "outline" | "secondary"
}) {
  const { theme, toggle, mounted } = useTheme()

  if (!mounted) {
    return (
      <Button size={size} variant={variant} disabled aria-hidden suppressHydrationWarning>
        <span className="size-4" />
      </Button>
    )
  }

  return (
    <Button
      size={size}
      variant={variant}
      onClick={toggle}
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      {theme === "dark" ? <Moon className="size-4" /> : <Sun className="size-4" />}
    </Button>
  )
}
